import { forwardRef } from "react";

import { cn } from "@/lib/utils";
import { Label } from "./label";
import { ErrorLabel } from "./error-label";

type TDefaultInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "prefix" | "type">;

export type RadioInputProps = TDefaultInputProps & {
	label: string;
	error?: string;
	classNames?: { container?: string };
};

export const RadioInput = forwardRef<HTMLInputElement, RadioInputProps>(
	({ label, error, id, className, classNames, ...props }, ref) => {
		return (
			<div className={cn(classNames?.container)}>
				<div className="flex items-center gap-x-3">
					<input
						id={id}
						ref={ref}
						type="radio"
						className={cn(
							"h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600",
							className
						)}
						{...props}
					/>

					<Label id={id} className="mb-0 font-normal">
						{label}
					</Label>
				</div>

				{error && error.length > 1 && <ErrorLabel>{error}</ErrorLabel>}
			</div>
		);
	}
);
